/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Sub_Quickstart_Copy_ButtonInputs */



/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Gateway_Sub_Quickstart_Copy_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_quickstart_copy_button = /** @type {((inputs?: Gateway_Sub_Quickstart_Copy_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Quickstart_Copy_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kopieren")
	return /** @type {LocalizedString} */ ("Copy")
});